import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary, Iframe } from '@livingsecurity/shared';
import { useFlags } from 'launchdarkly-react-client-sdk';

const UnifyPublic = () => {
  const { unifyUrl } = useFlags();
  const location = useLocation();
  const [embeddedUrl, setEmbeddedUrl] = useState(null);

  useEffect(() => {
    if (!unifyUrl) return;

    let path = location.pathname.replace(/^\/+|\/+$/g, ''); // trim slashes
    if (!path.startsWith('unify')) path = `unify/${path}`;
    let url = `${unifyUrl.replace(/\/+$/, '')}/${path}`;
    if (location.search) url += location.search;

    setEmbeddedUrl(url);

    if (window.location?.href?.includes('livingsecurity.com')) {
      window.document.domain = 'livingsecurity.com';
    }
  }, [unifyUrl, location.pathname, location.search]);

  if (!embeddedUrl) return null;

  return (
    <ErrorBoundary scope="unify">
      <Iframe
        id="unify-embed-frame"
        allow="clipboard-read; clipboard-write *;"
        className="embedded-iframe"
        data-testid="unify-embed-frame"
        title="Living Security Unify"
        src={embeddedUrl}
      />
    </ErrorBoundary>
  );
};

export default UnifyPublic;
